import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type UneditedFutureOrdersTabProps = {
    label: string;
};

const UneditedFutureOrdersRoute = '/unedited-future-orders';

let routes = [UneditedFutureOrdersRoute];

function UneditedFutureOrdersTab({ label, ...props }: UneditedFutureOrdersTabProps) {
    function handleClick() {
        history.push(UneditedFutureOrdersRoute);
    }

    return (
        <BaseTab {...props} onClick={handleClick} label={label} route={UneditedFutureOrdersRoute} />
    );
}

function TranslatedUneditedFutureOrdersTab(props) {
    const label = Translate('header/nav/unedited-future-orders');
    return <UneditedFutureOrdersTab {...props} label={label} />;
}

TranslatedUneditedFutureOrdersTab.routes = routes;

export default TranslatedUneditedFutureOrdersTab;
